import { createReducer } from 'shared';
import { fetchQRCode } from 'redux/actions';
import uniq from 'lodash/uniq';

export const qrCodeIdsReducer = createReducer([], {
  [fetchQRCode]: (ids, action) => uniq([...ids, ...action.ids]),
});
